/* It's a search bar that filters the tasks based on the input */
import React, { Component } from "react"
import { Button, FormControl, Spinner } from "react-bootstrap"
import mutator from "src/utilities/mutator"
import taskManagerUtils from "../TaskManagerUtils/TaskManagerUtils"
import "./TaskManagerSearchTasks.css"

interface Props {
    tasks: Array<number>
    tasksCopy: Array<number>
    viewTypes: Array<{ id: number, active: boolean, title: string, endpoint: string, order: number }>,
    activeView: { id: number, active: boolean, title: string, endpoint: string, order: number },
    manageParentState: Function
    callParentFunction: Function
}

interface State {
    input: string | null
    busy: boolean
}

class TasksManagerSearchTasks extends Component<Props, State> {

    typingTimeout: number | any = 0

    state = {
        input: null,
        busy: false
    }

    /* A function that is used to update the state. It is used to prevent the state from being updated in
    an uncontrolled manner. */
    manageState = (keys: Array<{ key: string, value?: any }>) => {
        this.setState(mutator.mutate(this.state, keys))
    }

    /* Filtering the tasks based on the input. */
    filterTasks = (input: string, tasks: Array<number>) => {
        let temp: any = []
        for (let i = 0; i < tasks.length; i++) {
            const taskName = (taskManagerUtils.lookupItem(`${tasks[i]}`)[3]).replace(/ /g, "").toLowerCase()
            if (taskName.includes(input.toLowerCase())) {
                temp.push(tasks[i])
            }
        }
        this.props.manageParentState([{ key: "tasks", value: temp }, { key: "searching", value: input.length > 0 ? true : false }])
        this.manageState([{ key: "busy", value: false }])
    }

    /* A debounce function. */
    debounce = (event: { target: { value: string } }) => {
        const input = event.target.value.toLowerCase()
        this.manageState([{ key: "input", value: input }, { key: "busy", value: true }])
        if (this.typingTimeout) {
            clearTimeout(this.typingTimeout);
        }
        this.typingTimeout = setTimeout(() => {
            if (input.length > 0) {
                this.filterTasks(input, this.props.tasksCopy)
            } else {
                this.props.manageParentState([{ key: "tasks", value: this.props.tasksCopy }])
                this.manageState([{ key: "busy", value: false }])
            }
        }, 500)
    }

    render() {

        const state = this.state
        const props = this.props
        const searchDisabled = props.tasksCopy.length === 0
        const placeholderString = searchDisabled ? "Nothing to search..." : `Search ${props.activeView.title}`

        // //console.log("df_TaskManagerSearchTasks props", props)
        // //console.log("df_TaskManagerSearchTasks state", state)

        return (
            <div className="TaskManagerSearchTasks">
                <div className="TasksManagerSearchTasksInput">
                    <div className="TasksManagerSearchTasksInputLeft">
                        <FormControl
                            onChange={this.debounce}
                            placeholder={placeholderString}
                            value={this.state.input || ""}
                            type="text"
                            disabled={searchDisabled}
                        />
                    </div>
                    <div className="TasksManagerSearchTasksInputRight">
                        <div className="TasksManagerSearchTasksInputRightViewTypeItems">
                            {props.viewTypes.map((item) =>
                                <div className={`TasksManagerSearchTasksInputRightViewTypeItem ${item.active ? "TasksManagerSearchTasksInputRightViewTypeItemActive" : "TasksManagerSearchTasksInputRightViewTypeItemInactive"}`}
                                    key={`task-manager-search-tasks-${item.id}`}
                                    onClick={!item.active ? () => props.callParentFunction("setView", item.id) : () => null}
                                >
                                    {item.title}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <div className="TasksManagerSearchTasksBusy">
                    {state.busy && <Spinner id="search-tasks-busy-spinner" animation="border" />}
                </div>
                {state.input && props.tasks.length === 0 && <div className="TasksManagerSearchTasksNotasksFound">
                    <span className="TasksManagerSearchTasksNotasksFoundErrEmoji">{`(>_<)`}</span>
                    <p>{`No tasks found for "${state.input}"`}</p>
                    <Button variant="secondary" onClick={() => this.debounce({ target: { value: "" } })}>Reset your filters and try again?</Button>
                </div>}
            </div>
        )
    }
}

export default TasksManagerSearchTasks